import React from 'react';
import { Box, Typography } from '@mui/material';
import VendedorForm from '../components/vendedor/VendedorForm';

const VendedorNovo: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Novo Vendedor
      </Typography>
      <VendedorForm />
    </Box>
  );
};

export default VendedorNovo;
